module.exports = __webpack_public_path__ + "assets/img/activity-time-174d2243.png";